module.exports = __webpack_public_path__ + "static/media/r_itdot_9.0a3360fb.png";